import { render, staticRenderFns } from "./ImzalayiciV1.vue?vue&type=template&id=5661a9f7&scoped=true&"
import script from "./ImzalayiciV1.vue?vue&type=script&lang=js&"
export * from "./ImzalayiciV1.vue?vue&type=script&lang=js&"
import style0 from "./ImzalayiciV1.vue?vue&type=style&index=0&id=5661a9f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5661a9f7",
  null
  
)

export default component.exports